// src/hooks/useOwners.js
import { useAppContext } from '../components/context/AppContext';

/**
 * Global state hook for owners management
 * Connects to AppContext for centralized state management
 */
export const useOwners = () => {
    const { state, actions } = useAppContext();

    // Global state from AppContext
    const owners = state.owners || [];
    const ownerSubmited = state.ownerSubmited;
    const isLoading = state.loading;
    const error = state.error;

    return {
        // State
        owners,
        ownerSubmited,
        ownersCount: owners.length,
        isLoading,
        loading: isLoading, // Backward compatibility
        error,
        
        // Actions
        fetchOwners: actions.fetchOwners,
        createOwner: actions.createOwner,
        updateOwner: actions.updateOwner,
        deleteOwner: actions.deleteOwner,

        // Utility functions
        getOwnerById: (ownerId) => {
            return owners.find(owner => owner.ownerId === ownerId);
        },

        getOwnerByHomeNumber: (homeNumber) => {
            return owners.find(owner => owner.homeNumber === homeNumber);
        },

        getOwnersByFracc: (fraccName) => {
            return owners.filter(owner => owner.fracc === fraccName);
        },

        getOwnersByStatus: (status) => {
            return owners.filter(owner => owner.status === status);
        },

        getActiveOwners: () => {
            return owners.filter(owner => owner.status === 'active' || !owner.status);
        },

        getInactiveOwners: () => {
            return owners.filter(owner => owner.status === 'inactive');
        },

        searchOwners: (searchTerm) => {
            if (!searchTerm) return owners;
            const term = searchTerm.toLowerCase();
            return owners.filter(owner => 
                (owner.name && owner.name.toLowerCase().includes(term)) ||
                (owner.email && owner.email.toLowerCase().includes(term)) ||
                (owner.phone && owner.phone.toLowerCase().includes(term)) ||
                (owner.homeNumber && owner.homeNumber.toString().includes(term))
            );
        },

        getTotalOwners: () => owners.length,

        getOwnersByContactInfo: (contactInfo) => {
            return owners.filter(owner => 
                (owner.email && owner.email.includes(contactInfo)) ||
                (owner.phone && owner.phone.includes(contactInfo))
            );
        },

        validateOwnerData: (ownerData) => {
            const errors = [];
            if (!ownerData.name) errors.push('Name is required');
            if (!ownerData.email) errors.push('Email is required');
            if (!ownerData.homeNumber) errors.push('Home number is required');
            return {
                isValid: errors.length === 0,
                errors
            };
        }
    };
};

export default useOwners;